import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'safr47',
  Description:
    'Here&#39;s all the online content included with your <strong>Combined Science Revision Guide</strong>.',
  Credits:
    '<p><i>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2025.&nbsp; All rights reserved.</i></p>\n',
};
